import { Row, Col, Form, Input, Radio, Select, Typography } from "antd";
import { Activity } from "lucide-react";

const { Title } = Typography;
const { Option } = Select;

export default function StepVitals({ formData, onChangeField, errors = {} }) {
  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
          <Activity className="w-6 h-6 text-[#0B7BC1]" />
        </div>
        <Title level={4} style={{ margin: 0 }}>
          Vitals
        </Title>
      </div>

      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item
            label={
              <>
                Age (years) <span className="text-red-500">*</span>
              </>
            }
            required
            validateStatus={errors.age ? "error" : ""}
            help={errors.age}
          >
            <Input
              type="number"
              placeholder="Enter age"
              value={formData.age}
              onChange={(e) => onChangeField("age", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item
            label={
              <>
                Gender <span className="text-red-500">*</span>
              </>
            }
            required
            validateStatus={errors.gender ? "error" : ""}
            help={errors.gender}
          >
            <Select
              placeholder="Select gender"
              value={formData.gender || undefined}
              onChange={(value) => onChangeField("gender", value)}
              allowClear
            >
              <Option value="male">Male</Option>
              <Option value="female">Female</Option>
              <Option value="other">Other</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item
            label={
              <>
                Weight (kg) <span className="text-red-500">*</span>
              </>
            }
            required
            validateStatus={errors.weight ? "error" : ""}
            help={errors.weight}
          >
            <Input
              type="number"
              placeholder="Enter weight"
              value={formData.weight}
              onChange={(e) => onChangeField("weight", e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item label="Age Category">
            <Radio.Group
              value={formData.ageCategory}
              onChange={(e) => onChangeField("ageCategory", e.target.value)}
            >
              <Radio value="adult">Adult</Radio>
              <Radio value="pediatric">Pediatric</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        {formData.gender === "female" && (
          <Col xs={24} md={12}>
            <Form.Item label="Pregnancy">
              <Radio.Group
                value={formData.pregnancy}
                onChange={(e) => onChangeField("pregnancy", e.target.value)}
              >
                <Radio value="no">No</Radio>
                <Radio value="yes">Yes</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        )}
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item label="BP (mmHg)">
            <Input
              placeholder="120/80"
              value={formData.bp}
              onChange={(e) => onChangeField("bp", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item label="HR (bpm)">
            <Input
              type="number"
              placeholder="72"
              value={formData.hr}
              onChange={(e) => onChangeField("hr", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item label="Temp (°F)">
            <Input
              type="number"
              placeholder="98.6"
              value={formData.temp}
              onChange={(e) => onChangeField("temp", e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item label="SpO2 (%)">
            <Input
              type="number"
              placeholder="98"
              value={formData.spo2}
              onChange={(e) => onChangeField("spo2", e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="RR (breaths/min)">
            <Input
              type="number"
              placeholder="16"
              value={formData.rr}
              onChange={(e) => onChangeField("rr", e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item label="Mental Status">
            <Select
              placeholder="Select mental status"
              value={formData.mentalStatus || undefined}
              onChange={(value) => onChangeField("mentalStatus", value)}
              allowClear
            >
              <Option value="alert">Alert</Option>
              <Option value="confused">Confused</Option>
              <Option value="drowsy">Drowsy</Option>
              <Option value="unresponsive">Unresponsive</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}

